import React, { useEffect, useState } from 'react';
import './Login.scss';
import api from '../Axios/axios';
import logo2 from '../../assets/starcraneLogo.png';
import { useNavigate } from 'react-router-dom';

const text = {
  appTitle: 'Kule Vin\u00e7 Takip Sistemi',
  login: 'Giri\u015f Yap',
  password: '\u015eifre',
  forgotPassword: '\u015eifremi Unuttum?',
  resetCodeTitle: '\u015eifre S\u0131f\u0131rlama - Kod G\u00f6nder',
  resetPasswordTitle: '\u015eifre S\u0131f\u0131rlama - Yeni \u015eifre',
  sendCode: 'Kod G\u00f6nder',
  updatePassword: '\u015eifreyi G\u00fcncelle',
  newPassword: 'Yeni \u015fifre',
  repeatNewPassword: 'Yeni \u015fifre (tekrar)',
  loginFailed: 'Giri\u015f ba\u015far\u0131s\u0131z. Bilgilerinizi kontrol edin.',
  unexpectedError: 'Beklenmeyen bir hata olu\u015ftu. L\u00fctfen tekrar deneyin.',
  serverUnavailable: 'Sunucudan yan\u0131t al\u0131namad\u0131. L\u00fctfen tekrar deneyin.',
  genericError: 'Bir hata olu\u015ftu. L\u00fctfen tekrar deneyin.',
  codeSent: 'Kod g\u00f6nderildi. L\u00fctfen e-postan\u0131z\u0131 kontrol edin.',
  codeSendError: 'Kod g\u00f6nderilirken hata olu\u015ftu. L\u00fctfen ge\u00e7erli bir e-posta girin.',
  shortPassword: '\u015eifreniz en az 6 karakter olmal\u0131!',
  passwordMismatch: 'Yeni \u015fifre ve tekrar \u015fifre uyu\u015fmuyor.',
  passwordUpdated: '\u015eifreniz ba\u015far\u0131yla g\u00fcncellendi. Yeni \u015fifrenizle giri\u015f yapabilirsiniz.',
  passwordUpdateError: '\u015eifre g\u00fcncellenirken bir hata olu\u015ftu. L\u00fctfen kod ve \u015fifreyi kontrol edin.',
  passwordUpdatedInline: '\u015eifre ba\u015far\u0131yla g\u00fcncellendi!',
};

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isForgotModalOpen, setIsForgotModalOpen] = useState(false);
  const [isResetModalOpen, setIsResetModalOpen] = useState(false);
  const [forgotEmail, setForgotEmail] = useState('');
  const [resetCode, setResetCode] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loginError, setLoginError] = useState(null);
  const [resetError, setResetError] = useState(null);
  const [resetSuccess, setResetSuccess] = useState(false);

  const navigate = useNavigate();

  const getDefaultRouteByRole = (role) => {
    if (role === 'TechnicalServiceManager') {
      return '/technical-service';
    }

    if (role === 'TechnicalServicePersonnel') {
      return '/technical-service/my-jobs';
    }

    return '/home';
  };

  useEffect(() => {
    const token = localStorage.getItem('token');
    const hash = window.location.hash || '';
    if (!token || !hash.startsWith('#technical-service-')) return;

    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      const userRole = payload['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'];
      if (userRole === 'TechnicalServiceManager') {
        const panel = hash.replace('#technical-service-', '');
        navigate(`/technical-service?panel=${panel}`, { replace: true });
      }
    } catch {
      localStorage.removeItem('token');
    }
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await api.post('/Auth/Login', { email, password });
      if (response.status === 200 && response.data.data?.token) {
        const token = response.data.data.token;
        localStorage.setItem('token', token);
        setLoginError(null);

        const base64Payload = token.split('.')[1];
        const payload = JSON.parse(atob(base64Payload));
        const userRole = payload['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'];

        navigate(getDefaultRouteByRole(userRole));
      } else {
        setLoginError(text.unexpectedError);
      }
    } catch (error) {
      if (error.response) {
        setLoginError(error.response.data.message || text.loginFailed);
      } else if (error.request) {
        setLoginError(text.serverUnavailable);
      } else {
        setLoginError(text.genericError);
      }
    }
  };

  const handleForgotPasswordSubmit = async (e) => {
    e.preventDefault();
    setResetError(null);
    setResetSuccess(false);

    try {
      await api.post('/Auth/ForgetPassword', {
        email: forgotEmail,
      });
      alert(text.codeSent);
      setIsForgotModalOpen(false);
      setIsResetModalOpen(true);
    } catch (error) {
      console.error('Kod gonderme hatasi:', error);
      setResetError(error.response?.data?.message || text.codeSendError);
    }
  };

  const handleResetPasswordSubmit = async (e) => {
    e.preventDefault();
    setResetError(null);
    setResetSuccess(false);

    if (newPassword.length < 6) {
      setResetError(text.shortPassword);
      return;
    }
    if (newPassword !== confirmPassword) {
      setResetError(text.passwordMismatch);
      return;
    }

    try {
      await api.post('/Auth/CreateNewPassword', {
        email: forgotEmail,
        code: resetCode,
        password: newPassword,
      });

      setResetSuccess(true);
      alert(text.passwordUpdated);
      setIsResetModalOpen(false);
    } catch (error) {
      console.error('Yeni sifre olusturma hatasi:', error);
      setResetError(error.response?.data?.message || text.passwordUpdateError);
    }
  };

  return (
    <div className="app-container">
      <div className="login-container">
        <h1>{text.appTitle}</h1>
        <div className="logos">
          <img src={logo2} alt="StarCrane Logo" data-build="encoding-fix-20260602b" />
        </div>
        <div className="login-form-container">
          <h2>{text.login}</h2>
          <form onSubmit={handleSubmit}>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Email"
              required
            />
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder={text.password}
              required
            />
            <button type="submit">{text.login}</button>
            {loginError && <p className="error-message">{loginError}</p>}

            <a
              href="#"
              className="forgot-password"
              onClick={() => {
                setForgotEmail('');
                setIsForgotModalOpen(true);
                setResetError(null);
                setResetSuccess(false);
              }}
            >
              {text.forgotPassword}
            </a>
          </form>
        </div>

        {isForgotModalOpen && (
          <div className="modal-overlay">
            <div className="modal-content">
              <span
                className="close-modal"
                onClick={() => setIsForgotModalOpen(false)}
              >
                &times;
              </span>
              <h3>{text.resetCodeTitle}</h3>
              <form onSubmit={handleForgotPasswordSubmit}>
                <input
                  type="email"
                  value={forgotEmail}
                  onChange={(e) => setForgotEmail(e.target.value)}
                  placeholder="Email adresinizi girin"
                  required
                />
                <button type="submit">{text.sendCode}</button>
              </form>
              {resetError && <p className="error-message">{resetError}</p>}
            </div>
          </div>
        )}

        {isResetModalOpen && (
          <div className="modal-overlay">
            <div className="modal-content">
              <span
                className="close-modal"
                onClick={() => setIsResetModalOpen(false)}
              >
                &times;
              </span>
              <h3>{text.resetPasswordTitle}</h3>
              <form onSubmit={handleResetPasswordSubmit}>
                <input
                  type="email"
                  value={forgotEmail}
                  readOnly
                  disabled
                  style={{ backgroundColor: '#f2f2f2' }}
                />
                <input
                  type="text"
                  value={resetCode}
                  onChange={(e) => setResetCode(e.target.value)}
                  placeholder="Eposta ile gelen kod"
                  required
                />
                <input
                  type="password"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  placeholder={text.newPassword}
                  required
                />
                <input
                  type="password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  placeholder={text.repeatNewPassword}
                  required
                />
                <button type="submit">{text.updatePassword}</button>
              </form>
              {resetError && <p className="error-message">{resetError}</p>}
              {resetSuccess && (
                <p className="success-message">{text.passwordUpdatedInline}</p>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Login;
